import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContaReceber } from '../page/conta-receber/contareceber';
import { PaginacaoContaReceber } from '../page/conta-receber/paginacaoContaReceber';

@Injectable({
  providedIn: 'root'
})
export class ContaReceberService {

  apiURL: string = environment.apiBaseUrl + 'contaReceber';

  constructor(private http: HttpClient) { }

  save(contaReceber: ContaReceber): Observable<ContaReceber> {
    
    return this.http.post<ContaReceber>(this.apiURL, contaReceber);
  }

  list(page: number, size: number): Observable<PaginacaoContaReceber> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }  

  update(contaReceber: ContaReceber): Observable<any> {
    return this.http.put<ContaReceber>(`${this.apiURL}/${contaReceber.id}`, contaReceber);
  }

  findClientById(id: number): Observable<ContaReceber> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<ContaReceber> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

    findContaReceber(page: number, size: number, dataInicio: string, dataFim: string, tipoFiltro: string, pagador: string, situacao?: string | null): Observable<PaginacaoContaReceber> {
      let params = new HttpParams()
        .set('page', page.toString())
        .set('size', size.toString())
        .set('dataInicio', dataInicio)
        .set('dataFim', dataFim)
        .set('tipoFiltro', tipoFiltro)
        .set('pagador', pagador);
      if (situacao) {
        params = params.set('situacao', situacao);
      }
      return this.http.get<any>(`${this.apiURL}/consulta?${params.toString()}`);
    }

    listarAReceber(tamanho: number, pagina: number): Observable<PaginacaoContaReceber> {
      const params = new HttpParams().set('page', pagina.toString()).set('size', tamanho.toString())
    return this.http.get<PaginacaoContaReceber>(`${this.apiURL}/listaAReceber?${params.toString()}`);
  }

  emitirBoleto(id: number): Observable<ContaReceber> {
    return this.http.post<ContaReceber>(`${this.apiURL}/${id}/cobranca/boleto`, {});
  }

  emitirPix(id: number): Observable<ContaReceber> {
    return this.http.post<ContaReceber>(`${this.apiURL}/${id}/cobranca/pix`, {});
  }

  downloadBolepix(id: number): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${id}/bolepix`, { responseType: 'blob' });
  }

  downloadComprovantePix(id: number): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${id}/comprovante-pix`, { responseType: 'blob' });
  }

  registrarBaixa(id: number, formaPagamento: string, valor: number | null, dataPagamento: string, arquivo: File | null): Observable<ContaReceber> {
    const formData = new FormData();
    formData.append('formaPagamento', formaPagamento);
    if (arquivo) {
      formData.append('arquivo', arquivo, arquivo.name);
    }
    if (valor != null) {
      formData.append('valor', String(valor));
    }
    if (dataPagamento) {
      formData.append('dataPagamento', dataPagamento);
    }
    return this.http.post<ContaReceber>(`${this.apiURL}/${id}/baixa`, formData);
  }

  anexarFatura(id: number, arquivo: File): Observable<ContaReceber> {
    const formData = new FormData();
    formData.append('arquivo', arquivo, arquivo.name);
    return this.http.post<ContaReceber>(`${this.apiURL}/${id}/anexo/fatura`, formData);
  }

  downloadAnexo(id: number, tipo: 'fatura' | 'baixa'): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${id}/anexo/${tipo}`, { responseType: 'blob' });
  }
}